<div class="bg-blue px-4 px-md-5 px-xxl-4">
  <br><br>
  <div class="content-section">
    <div class="row">
      <div class="col-md-6 col-lg-6 col-xl-3 mb-5 mb-xl-0 text-center text-sm-start">
        <img [src]="contentFooter.logo" class="logo" alt="">
      </div>
      <div class="col-md-6 col-lg-6 col-xl-3 mb-2 mb-xl-0" *ngFor="let nav of contentFooter.navigation">
        <div class="d-flex">
          <div>
            <img [src]="nav.icon" alt="">
          </div>
          <div class="ps-3">
            <div class="mb-3">
              <span class="text-white fs-4 fw-bold">{{nav.title}}</span>
            </div>
            <div *ngFor="let op of nav.options" class="mb-3">
              <span class="text-white fw-regular pointer" (click)="goTo(op.router)">{{op.name}}</span>
            </div>
            <div class="d-flex">
              <a [href]="so.url" target="_blank" *ngFor="let so of nav.social">
                <img [src]="so.icon" class="me-2" alt="icon.svg" width="40">
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br><br>
  </div>
  <div class="py-3 border-top">
    <div class="row content-section m-auto">
      <div class="col-md-6">
        <span class="text-white fw-light">{{contentFooter.policy}}</span>
      </div>
      <div class="col-md-6 text-start text-md-end">
        <a href="https://api.whatsapp.com/send?phone=+51999155842&text=Hola Zeventee" target="_blank">
          <span class="text-white" [innerHtml]="contentFooter.develop"></span>
        </a>
      </div>
    </div>
  </div>
</div>
